import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { SlArrowRightCircle } from "react-icons/sl";
import axios from "axios";

import {
  CalendarHome,
  DivisionsList,
  Loading,
  PlayoffMatches,
} from "../components";

import {
  api_v3_get_tournament_by_id,
  api_v3_get_playoff_matches_by_tournament,
} from "../utils/constants";

const HomeTournament = () => {
  const { tournamentId } = useParams();
  const [divisionsInProgress, setDivisionsInProgress] = useState(true);
  const [divisionsError, setDivisionsError] = useState(false);
  const [divisionsCompleted, setDivisionsCompleted] = useState(false);
  const [divisions, setDivisions] = useState([]);
  const [tournament, setTournament] = useState({});

  const [playoffMatches, setPlayoffMatches] = useState([]);
  const [playoffInProgress, setPlayoffInProgress] = useState(true);
  const [playoffError, setPlayoffError] = useState(false);

  useEffect(() => {
    const loadDivisions = async () => {
      const url = api_v3_get_tournament_by_id(tournamentId);

      try {
        setDivisionsInProgress(true);
        const response = await axios.get(url);
        if (response.status === 200) {
          const divs = response.data.divisions.sort((a, b) =>
            a.sequence > b.sequence ? 1 : -1
          );
          setTournament(response.data);
          setDivisions(divs);
          setDivisionsInProgress(false);
          setDivisionsError(false);
          setDivisionsCompleted(true);
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          setDivisionsInProgress(false);
          setDivisionsError(true);
          return false;
        }
      } catch (error) {
        setDivisionsInProgress(false);
        setDivisionsError(true);
        return false;
      }
    };

    loadDivisions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadPlayoffs = async () => {
      const url = api_v3_get_playoff_matches_by_tournament(tournamentId);

      try {
        setPlayoffInProgress(true);
        const response = await axios.get(url);
        if (response.status === 200) {
          const matches = response.data;
          setPlayoffMatches(matches);
          setPlayoffInProgress(false);
          setPlayoffError(false);
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          setPlayoffInProgress(false);
          setPlayoffError(true);
          return false;
        }
      } catch (error) {
        setPlayoffInProgress(false);
        setPlayoffError(true);
        return false;
      }
    };
    loadPlayoffs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper>
      <Row>
        <Column12>
          <Label>
            {tournament.startDate ? tournament.startDate.slice(0, 4) : ""}
          </Label>
          <h4>{tournament.name}</h4>
          <p>Consulta toda la información de la {tournament.name}.</p>
          <br />
          <br />
          <br />
          <br />
          <Link to={`/tournament/${tournamentId}`}>
            <button className="btn2">
              <SlArrowRightCircle />
              Leer más
            </button>
          </Link>
        </Column12>
      </Row>
      <Row>
        <Column12>
          <Label>{tournament.name}</Label>
          <h4>Divisiones</h4>
          {divisionsInProgress ? <Loading /> : ""}

          {divisionsCompleted && !divisionsError && !divisionsInProgress ? (
            <DivisionsList divisions={divisions} />
          ) : (
            ""
          )}
        </Column12>
      </Row>
      <Row>
        <Column12>
          <Label>{tournament.name}</Label>
          <h4>Playoffs</h4>
          {playoffInProgress ? <Loading /> : ""}
          {playoffError ? (
            <p>
              Ha ocurrido un error cargando los partidos de playoff. Recarga la
              página
            </p>
          ) : (
            ""
          )}
          {!playoffInProgress && !playoffError && playoffMatches ? (
            <PlayoffMatches matches={playoffMatches} />
          ) : (
            ""
          )}
        </Column12>
      </Row>
      <Row>
        {divisionsCompleted && !divisionsError && !divisionsInProgress ? (
          <CalendarHome
            startDate={tournament.startDate}
            endDate={tournament.endDate}
            periods={tournament.periods}
            milestones={tournament.milestones}
            tournamentId={tournamentId}
            divisions={divisions}
          />
        ) : (
          ""
        )}
      </Row>
    </Wrapper>
  );
};

const Label = styled.div`
  background-color: var(--clr-violet);
  width: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.75rem;
`;

const Row = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.5vw;
  flex-wrap: wrap;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
const Column12 = styled.div`
  width: 100%;
  border: 1px solid var(--clr-grey-9);
  border-radius: 0.75rem;
  padding: 1rem;
  min-height: 26vh;
  height: 100%;
  @media (max-width: 1000px) {
    padding: 0.4rem;
    width: 100%;
  }
`;

const Wrapper = styled.main`
  margin: 2rem;

  @media (max-width: 1000px) {
    margin: 0rem;
  }
`;

export default HomeTournament;
